import axios from 'axios';

import routes from 'app/routes';

export default {
  requestTraining: (affiliateId, successCallback) => {
    axios
      .patch(routes.api.affiliates.requestTraining(affiliateId))
      .then((_response) => {
        successCallback();
      });
  },

  markTrainingStepCompleted: (trainingStepId, successCallback) => {
    axios
      .post(routes.api.affiliateTrainings.markCompleted, { step_id: trainingStepId })
      .then((_response) => {
        successCallback();
      });
  },

  markTrainingStepDocumentAsRead: (affiliateTrainingStepDocumentId, successCallback) => {
    axios
      .post(routes.api.affiliateTrainingStepDocuments.markAsRead(affiliateTrainingStepDocumentId))
      .then((_response) => {
        successCallback();
      });
  },
};
